import { FALLBACK_SESSION_ID } from '../components/MagicApronAssistant/constants';

export const SESSION_TIMEOUT = 60 * 60 * 1000; // 1 hour

/**
 * Returns a string to be used as session ID.
 *
 * @return { string }
 */
export const getSessionId = () => {
  return window !== undefined
    ? window?.cookieUtils?.readBrowserCookie('thda.s') || FALLBACK_SESSION_ID : FALLBACK_SESSION_ID;
};

export const getDefaultSession = () => ({
  sessionId: getSessionId(),
  timestamp: Date.now(),
  shouldOpenDrawer: true,
  hasSessionInteractedWithFab: false
});

/**
 * @typedef { Object } Session
 * @property { string } sessionId - User ID string used as sessionId.
 * @property { number } sessionTimestamp - Timestamp when session was created.
 */

/**
 * Check if provided session has expired.
 *
 * @param { Session } session - Session information
 * @return { boolean }
 */
export const sessionIsExpired = (session) => {
  // Handle case where session ID is falsy
  if (!session.sessionId) return true;

  // Handle case where the fallback session ID was used
  if (session.sessionId === FALLBACK_SESSION_ID) {
    return (Date.now() - session.timestamp) > SESSION_TIMEOUT;
  }
  return getSessionId() !== session.sessionId;
};
